import React, { useEffect, useState } from 'react';
import { MapPin, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const PURCHASES = [{
  name: 'María G.',
  city: 'Córdoba'
}, {
  name: 'Javier S.',
  city: 'CABA'
}, {
  name: 'Lucía M.',
  city: 'Rosario'
}, {
  name: 'Diego F.',
  city: 'Mendoza'
}, {
  name: 'Ana P.',
  city: 'Mar del Plata'
}, {
  name: 'Carlos R.',
  city: 'La Plata'
}, {
  name: 'Sofía T.',
  city: 'Tucumán'
}, {
  name: 'Martín L.',
  city: 'Salta'
}];
export function PurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState<(typeof PURCHASES)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showRandomPurchase = () => {
      const randomPerson = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPerson);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showRandomPurchase, 5000);
    // Show a new one every 15-25 seconds
    const interval = setInterval(() => {
      showRandomPurchase();
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-147">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-lg shadow-xl border border-teal-100 p-3 z-50 flex items-start gap-3" data-id="element-148">
          <div className="bg-teal-100 p-2 rounded-full flex-shrink-0" data-id="element-149">
            <MapPin className="w-5 h-5 text-teal-600" data-id="element-150" />
          </div>
          <div className="flex-1" data-id="element-151">
            <p className="text-sm text-slate-800" data-id="element-152">
              <span className="font-bold" data-id="element-153">{currentPurchase.name}</span> de{' '}
              {currentPurchase.city}
            </p>
            <p className="text-xs text-teal-600 font-medium" data-id="element-154">
              Acaba de comprar el Kit RRHH
            </p>
            <p className="text-[10px] text-slate-400 mt-1" data-id="element-155">Hace unos minutos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600" data-id="element-156">
            <X className="w-4 h-4" data-id="element-157" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}